import { ref, watch } from 'vue'
import throttle from 'lodash/throttle'

const InfiniteScroll = ({ loadMore, lastPageReachedRef, distanceFromBottom, scrollThrottleDelay }) => {
  let scrolledToThresholdRef = ref(false);

  watch(
    // watched references
    [scrolledToThresholdRef, lastPageReachedRef],
    // current and previous values for these references
    ([scrolledToThreshold, lastPageReached], [prevScrolledToThreshold, prevLastPageReached]) => {
      if ((scrolledToThreshold == prevScrolledToThreshold) &&
          (lastPageReached == prevLastPageReached))
        return;

      if (lastPageReached || !scrolledToThreshold) return;

      loadMore();
  });

  const onScroll = throttle(() => {
    const bottomOfWindowPosition = (window.pageYOffset || document.documentElement.scrollTop) + window.innerHeight;
    const loadingThresholdPosition = document.documentElement.offsetHeight - distanceFromBottom;

    scrolledToThresholdRef.value = bottomOfWindowPosition > loadingThresholdPosition;
  }, scrollThrottleDelay, { leading: true, trailing: true });

  document.addEventListener("scroll", onScroll);
}

export default InfiniteScroll;
